import React, { useEffect, useState } from "react";
import "../styles/style.css";
import "../styles/DashboardPage.css";
import { useNavigate } from "react-router-dom";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import facebook from "../assets/images/facebook.png";
import twitter from "../assets/images/twitter.png";
import linkedin from "../assets/images/linkedin.png";
import instagram from "../assets/images/instagram.png";
import youtube from "../assets/images/youtube.png";
import hambmenu from "../assets/images/hambmenu.png";
import blog from "../assets/images/blog.png";
import podcast from "../assets/images/podcast.png";
import features from "../assets/images/features.png";
import vlog from "../assets/images/vlog.png";
import art from "../assets/images/art.png";
import career from "../assets/images/career.png";
import matrimonial from "../assets/images/matrimonial.png";
import events from "../assets/images/events.png";
import inspiring_stories from "../assets/images/inspiring-stories.png";
import community_news from "../assets/images/community-news.png";
import vastu from "../assets/images/vastu.png";
import gastronomics from "../assets/images/gastronomics.png";
import numerology from "../assets/images/numerology.png";
import astrology from "../assets/images/astrology.png";
import feng_shui from "../assets/images/feng-shui.png";
import config from "../services/config";
import { showAlert } from "../utilities/alertService";
import Loader from "../utilities/Loader";
import ProfileDialog from "../component/ProfileDialog";

const DashboardPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [socialData, setSocialData] = useState([]);
  const [image, setImage] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogShown, setDialogShown] = useState(false);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    getSocialMedia();
    getuserData();
  }, []);

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;
  //   if (file.size > 1024 * 1024) {
  //     alert("Please select an image smaller than 1MB.");
  //     return;
  //   }

  //   const reader = new FileReader();

  //   reader.onload = () => {
  //     // Make sure reader.result is a string and starts with data:image
  //     if (typeof reader.result === "string" && reader.result.startsWith("data:image")) {
  //       setImage(reader.result);
  //     } else {
  //       alert("Invalid image file. Please select a valid image.");
  //     }
  //   };
  //   reader.onerror = () => {
  //     alert("Error reading file. Please try again.");
  //   };

  //   reader.readAsDataURL(file); // ✅ converts the file to a Base64 data URL
  // };

  // const handleSaveImage = async () => {
  //   try {
  //     setLoading(true);
  //     if (!image) {
  //       
  //       showAlert("error", "Please upload an image before saving!");
  //       return;
  //     }
  //     const payload = {
  //       user_id: localStorage.getItem("id"),
  //       imageBase64: image
  //     }
  //     const response = await config.updateUserProfile(payload);
  //     if (response.status === true) {
  //       console.log("Profile image saved successfully:", response);
  //       setIsSaved(true);
  //       showAlert("success", "Profile image saved successfully!");
  //     }
  //     else {
  //       showAlert("error", "Profile image not saved!");
  //     }
  //   } catch (error) {
  //     showAlert("error", "Failed to save profile image!");
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // };

  const getSocialMedia = async () => {
    try {
      const payload = {
        company_id: 1, // Replace with actual company ID    
      };
      const response = await config.getSocialMediaByCompany(payload);
      if (response.success === true) {
        setSocialData(response.data);
        console.log("Social Media Data:", response.data);
      }
      else {
        console.error("Failed to fetch social media data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching social media data:", error);
    }
  }

 const getuserData = async () => {
  try {
    const payload = {
      user_id: localStorage.getItem("id"),
    };
    const response = await config.getUserProfile(payload);
    if (response.status === true && response.image_base64) {
      setProfileData(response.image_base64);
    }
  } catch (error) {
    console.error("Error fetching Profile Data:", error);
  }
};
  // const handleNextClick = async () => {
  //   try {
  //     if (profileData !== null) {
  //       // If you need to perform any async operations before navigation, do them here
  //       await navigate("/category", { state: { profileData } });
  //     } else {
  //       showAlert("error", "Please upload your profile picture before continuing!");
  //     }
  //   } catch (error) {
  //     console.error("Error while proceeding to the next page:", error);
  //     showAlert("error", "Something went wrong while proceeding!");
  //   }
  // };
  const handleNextClick = async () => {
    if (!profileData && !dialogShown) {
      setOpenDialog(true);
      setDialogShown(true); // ensure dialog doesn’t reopen or auto-close
    } else {
      // navigate("/category", { state: { profileData } });
      navigate("/category");
    }
  };

  return (
    <div className="dashbaordpage">
      <div className="bordertop">
        <div className="dbb_container">
          <div className="row verticalalign">
            {/* Logo Section */}
            <div
              className="col-md-2"
              // onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              <div className="logo-section">
                <div>
                  <img
                    src={bhrigu_logo}
                    alt="Bhrigu Logo"
                  />
                </div>
              </div>
            </div>
            {loading && <Loader />}
            <ProfileDialog
              open={openDialog}
              onClose={() => {
                setOpenDialog(false);
                setDialogShown(false);
              }}
              onSaveSuccess={(img) => {
                setProfileData(img);
                setOpenDialog(false);
                setDialogShown(false);
              }}
            />

            {/* Navigation */}
            <div className="col-md-10">
              <div className="row respomenu">
                <div className="respinsivenext">
                  <div id="nexti"></div>
                </div>
                <div className="col-md-12 topbarrow">
                  <span></span>
                </div>
                <div className="col-md-12">
                  {/* NEXT button only for mobile */}
                  <div className="nav-row">
                    <ul className="nav-list-row">
                      <li id="nextbtn">
                        <input
                          type="submit"
                          value="NEXT"
                          onClick={handleNextClick}
                        />
                      </li>
                      <li>
                        <button
                          className="hemburb"
                          onClick={() => setSidebarOpen(!sidebarOpen)}
                        >
                          <img src={hambmenu} alt="menu" />
                        </button>
                      </li>
                    </ul>
                  </div>
                  {/* Desktop Navigation */}
                  <nav className="desktop-nav">
                    <ul className="nav-dashboard">
                      <li>
                        <ul>
                          <li>
                            <a href="#">Home</a>
                          </li>
                          <li style={{ cursor: "pointer" }}>
                            <a onClick={() => navigate("/aboutus")}>About Us</a>
                          </li>
                        </ul>

                      </li>
                      <li>
                        <ul>
                          <li className="socialmediamenu">
                            <ul>
                              <li>
                                <a
                                  href={socialData.find((s) => s.platform === "Facebook")?.url || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fbSocial"
                                >
                                  <img
                                    src={facebook}
                                    alt="facebook"
                                    style={{
                                      width: "24px",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href={socialData.find((s) => s.platform === "Twitter")?.url || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fbSocial"
                                >
                                  <img
                                    src={twitter}
                                    alt="twitter"
                                    style={{
                                      width: "24px",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href={socialData.find((s) => s.platform === "LinkedIn")?.url || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fbSocial"
                                >
                                  <img
                                    src={linkedin}
                                    alt="linkedin"
                                    style={{
                                      width: "24px",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href={socialData.find((s) => s.platform === "YouTube")?.url || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={youtube}
                                    alt="youtube"
                                    style={{
                                      width: "34px",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href={socialData.find((s) => s.platform === "Instagram")?.url || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={instagram}
                                    alt="instagram"
                                    style={{
                                      width: "30px",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </a>
                              </li>
                              {/* NEXT button only for desktop */}


                            </ul>
                          </li>
                          <li>
                            <ul id="siginupin">
                              {/* <ul id="siginupin"> */}
                              {/* Only show profile li if there is no profileData */}
                              {/* {!profileData && (
                                <li id="profileicon">
                                  <div className="profile-wrapper">
                                    {!image ? (
                                      <>
                                        <label htmlFor="profile-upload" className="upload-placeholder">+</label>
                                        <input
                                          id="profile-upload"
                                          type="file"
                                          accept="image/*"
                                          onChange={handleImageChange}
                                          style={{ display: "none" }}
                                        />
                                      </>
                                    ) : (
                                      <img
                                        src={image}
                                        alt="Profile"
                                        className="profile-preview"
                                      />
                                    )}
                                  </div>
                                  {image && (
                                    <button className="save-button" onClick={handleSaveImage}>Save</button>
                                  )}
                                </li>
                              )} */}
                              <li id="nextbtn">
                                {/* <a href=""> */}
                                  <input
                                    type="submit"
                                    value="NEXT"
                                    onClick={handleNextClick}
                                  />
                                {/* </a> */}
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>

                  {/* Sidebar */}
                  {sidebarOpen && (
                    <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
                      <button className="close-btn" onClick={() => setSidebarOpen(false)}>
                        ✖
                      </button>
                      <ul>
                        <li>
                          <a href="#">Home</a>
                        </li>
                        <li>
                          <a onClick={() => navigate("/aboutus")}>About Us</a>
                        </li>
                        <li>
                          <a
                            href={socialData.find((s) => s.platform === "Facebook")?.url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fbSocial"
                          >
                            <img src={facebook} alt="facebook" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={socialData.find((s) => s.platform === "Twitter")?.url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fbSocial"
                          >
                            <img src={twitter} alt="twitter" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={socialData.find((s) => s.platform === "LinkedIn")?.url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fbSocial"
                          >
                            <img src={linkedin} alt="linkedin" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={socialData.find((s) => s.platform === "YouTube")?.url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={youtube} alt="youtube" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={socialData.find((s) => s.platform === "Instagram")?.url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={instagram} alt="instagram" />
                          </a>
                        </li>
                        {/* <li id="profileicon">
                          <a href=""></a>
                        </li> */}
                        {/* {!profileData && (
                          <li id="profileicon">
                            <div className="profile-wrapper">
                              {!image ? (
                                <>
                                  <label htmlFor="profile-upload" className="upload-placeholder">+</label>
                                  <input
                                    id="profile-upload"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    style={{ display: "none" }}
                                  />
                                </>
                              ) : (
                                <img
                                  src={image}
                                  alt="Profile"
                                  className="profile-preview"
                                />
                              )}
                            </div>
                            {image && (
                              <button className="save-button" onClick={handleSaveImage}>Save</button>
                            )}
                          </li>
                        )} */}
                      </ul>
                    </div>
                  )}

                </div>
                <div className="col-md-12 bottombarrow">
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Marquee Section */}
        <div className="dbb_container">
          <div className="row verticalalign">
            <div className="tag-cloud">
              <div>
                <marquee scrollAmount="5">
                  <a href="#" className="xxlarge color2 blogf">
                    <img src={blog} alt="blog" />
                  </a>
                </marquee>
                <marquee scrollAmount="6" direction="right">
                  <a href="#" className="medium color3 featuresh">
                    <img src={features} alt="features" />
                  </a>
                </marquee>
                <marquee scrollAmount="10">
                  <a href="#" className="small color1 vlogh">
                    <img src={vlog} alt="vlog" />
                  </a>
                </marquee>
              </div>

              <marquee scrollAmount="12" direction="right">
                <a href="#" className="xxxxxxlarge color2 podcasth">
                  <img src={podcast} alt="podcast" />
                </a>
              </marquee>
              <marquee scrollAmount="5">
                <a href="#" className="xxxxxxxxlarge color2 arth">
                  <img src={art} alt="art" />
                </a>
              </marquee>
              <marquee scrollAmount="4" direction="right">
                <a href="#" className="xxxxlarge color2 careerh">
                  <img src={career} alt="career" />
                </a>
              </marquee>
              <marquee scrollAmount="8">
                <a href="#" className="xxxxxlarge color2 matrimonialh">
                  <img src={matrimonial} alt="matrimonial" />
                </a>
              </marquee>
              <marquee scrollAmount="7" direction="right">
                <a href="#" className="xsmall color2 inspiring-storiesh">
                  <img
                    src={inspiring_stories}
                    alt="inspiring stories"
                  />
                </a>
              </marquee>
              <marquee scrollAmount="10">
                <a href="#" className="xxxlarge color3 eventsh">
                  <img src={events} alt="events" />
                </a>
              </marquee>
              <marquee scrollAmount="15" direction="right">
                <a href="#" className="xxlarge color2 community-newsh">
                  <img
                    src={community_news}
                    alt="community news"
                  />
                </a>
              </marquee>
              <marquee scrollAmount="5">
                <a href="#" className="xxxxxxxlarge color1 vastuh">
                  <img src={vastu} alt="vastu" />
                </a>
              </marquee>
              <marquee scrollAmount="10" direction="right">
                <a href="#" className="medium color2 gastronomicsh">
                  <img
                    src={gastronomics}
                    alt="gastronomics"
                  />
                </a>
              </marquee>
              <marquee scrollAmount="3">
                <a href="#" className="medium color1 numerologyh">
                  <img src={numerology} alt="numerology" />
                </a>
              </marquee>
              <marquee scrollAmount="5" direction="right">
                <a href="#" className="xxxlarge color3 astrologyh">
                  <img src={astrology} alt="astrology" />
                </a>
              </marquee>
              <marquee scrollAmount="9">
                <a href="#" className="xlarge color2 feng-shuih">
                  <img src={feng_shui} alt="feng shui" />
                </a>
              </marquee>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
